/**
 * Generated by orval v6.25.0 🍺
 * Do not edit manually.
 * pentest-copilot OPENAPI
 * pentest-copilot
 * OpenAPI spec version: 1.0.0
 */
import axios from "axios";
import type { AxiosRequestConfig, AxiosResponse } from "axios";
import { AppendixFile, ChangePentest, ChangeVuln, Command, CommandConnection, ContactInformation, CreateVuln, IOBlock, NetworkRequest, NetworkRequestConnection, Pentest, RoleType, Template, Vulnerability } from "./sdkStructs";

axios.defaults.baseURL = import.meta.env.VITE_API_URL;

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> =
  (<T>() => T extends X ? 1 : 2) extends <T>() => T extends Y ? 1 : 2 ? A : B;

type WritableKeys<T> = {
  [P in keyof T]-?: IfEquals<
    { [Q in P]: T[P] },
    { -readonly [Q in P]: T[P] },
    P
  >;
}[keyof T];

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (
  k: infer I,
) => void
  ? I
  : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>]
  ? {
    [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
  }
  : DistributeReadOnlyOverUnions<T>;

export const apiDownloadVulnCSV = <TData = AxiosResponse<any>>(
  token: string,
  pentestId: number,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    method: "GET",
    headers: headers,
    ...options,
  };

  return axios.get(
    `/api/vulnerabilities/download/csv/pentest/${pentestId}`,
    requestOptions,
  );
};

export const apiDownloadVulnJSON = <TData = AxiosResponse<any>>(
  token: string,
  pentestId: number,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    method: "GET",
    headers: headers,
    ...options,
  };

  return axios.get(
    `/api/vulnerabilities/download/json/pentest/${pentestId}`,
    requestOptions,
  );
};

export const apiDownloadIOBlockJSON = <TData = AxiosResponse<any>>(
  token: string,
  pentestId: number,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    method: "GET",
    headers: headers,
    ...options,
  };

  return axios.get(
    `/api/ioblock/download/json/pentest/${pentestId}`,
    requestOptions,
  );
};

export const apiDownloadIOBlockCSV = <TData = AxiosResponse<any>>(
  token: string,
  pentestId: number,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    method: "GET",
    headers: headers,
    ...options,
  };

  return axios.get(
    `/api/ioblock/download/csv/pentest/${pentestId}`,
    requestOptions,
  );
};

export const apiResendVerificationEmail = <TData = AxiosResponse<any>>(
  token: string,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    method: "GET",
    headers: headers,
    ...options,
  };

  return axios.get(
    `/api/user-details/resend-verification-email`,
    requestOptions,
  );
};

export const apiCheckFirstLogin = <TData = AxiosResponse<any>>(
  token: string,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    method: "GET",
    headers: headers,
    ...options,
  };

  return axios.get(`/api/user-details/first-login`, requestOptions);
};

export const apiFuzzyIOBlocksByPentest = <TData = AxiosResponse<IOBlock[]>>(
  token: string,
  pentestId: number,
  query: string,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    method: "GET",
    headers: headers,
    ...options,
  };

  return axios.get(
    `/api/ioblock/fuzzy/pentest/${pentestId}?query=${encodeURIComponent(query)}`,
    requestOptions,
  );
};

export const apiGetLatestIOBlocks = <TData = AxiosResponse<IOBlock[]>>(
  token: string,
  pentestId: number,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    method: "GET",
    headers: headers,
    ...options,
  };

  return axios.get(`/api/ioblock/latest/pentest/${pentestId}`, requestOptions);
};

export const apiGetLatestIOBlocksWithoutLimit = <
  TData = AxiosResponse<IOBlock[]>,
>(
  token: string,
  pentestId: number,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    method: "GET",
    headers: headers,
    ...options,
  };

  return axios.get(
    `/api/ioblock/latest/no-count/pentest/${pentestId}`,
    requestOptions,
  );
};

// Function to get IOBlocks by timestamp for a given pentest
export const apiGetIOBlocksByTimestamp = <TData = AxiosResponse<IOBlock[]>>(
  token: string,
  pentestId: number,
  count: number,
  timestamp: number,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    method: "GET",
    headers: headers,
    ...options,
  };

  return axios.get(
    `/api/ioblock/pentest/${pentestId}/count/${count}/timestamp/${timestamp}`,
    requestOptions,
  );
};

export const apiChangePassword = <TData = AxiosResponse<void>>(
  token: string,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  return axios.get(`/api/user-details/change-password`, {
    headers,
    ...options,
  });
};

export const apiLogoUpload = <TData = AxiosResponse<void>>(
  token: string,
  file: File,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const formData = new FormData();
  formData.append("logo", file);

  const headers = {
    Authorization: `Bearer ${token}`,
    // No need to set Content-Type manually for multipart/form-data. Axios sets it automatically.
  };

  return axios.post(`/api/user-details/upload/logo`, formData, {
    headers,
    ...options,
  });
};

export const apiImageUpload = <TData = AxiosResponse<any>>(
  token: string,
  file: File,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const formData = new FormData();
  formData.append("logo", file);

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  return axios.post("/api/uploads/images", formData, {
    headers,
    ...options,
  });
};

export const apiGetImage = <TData = AxiosResponse<Blob>>(
  token: string,
  url: string,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    method: "GET",
    headers: headers,
    responseType: "blob",
    ...options,
  };

  return axios.get(url, requestOptions);
};

// ------------------------------------------------------------------------------------------

export const apiNetworkRequestsPentestList = <
  TData = AxiosResponse<NetworkRequest[]>,
>(
  token: string,
  pentestId: number,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    method: "GET",
    headers: headers,
    ...options,
  };

  return axios.get(
    `/api/network_requests/pentest/${pentestId}`,
    requestOptions,
  );
};

export const apiUserDetailsRetrieve = <TData = AxiosResponse<ContactInformation>>( // TODO: used to be ugly contact information
  token: string,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  return axios.get(`/api/user-details/`, {
    ...options,
    headers,
  });
};

export const apiNetworkRequestPentestVulnerabilityList = <
  TData = AxiosResponse<NetworkRequest[]>,
>(
  token: string,
  pentestId: number,
  vulnID: number,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    method: "GET",
    headers: headers,
    ...options,
  };

  return axios.get(
    `/api/network_requests/pentest/${pentestId}/vulnerability/${vulnID}`,
    requestOptions,
  );
};

export const apiCommandVulnerabilityAssociationsDelete = <
  TData = AxiosResponse<void>,
>(
  token: string,
  data: CommandConnection,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const config = {
    method: "delete",
    url: `/api/command-associations/`, // Adjust URL as needed
    headers: headers,
    data,
    ...options,
  };

  return axios.request(config);
};

export const apiCreateNetworkRequestAssociation = <TData = AxiosResponse<void>>(
  token: string,
  data: NetworkRequestConnection,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  return axios.post(`/api/network-associations/`, data, {
    headers,
    ...options,
  });
};

// Get list of commands
export const apiCommandsRetrieve = <TData = AxiosResponse<Command>>(
  token: string,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  return axios.get(`/api/commands/`, {
    ...options,
    headers,
  });
};

export const apiVulnerabilitiesRetrieve = <
  TData = AxiosResponse<Vulnerability[]>,
>(
  token: string,
  pentestId: number,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    method: "GET",
    headers: headers,
    ...options,
  };

  return axios.get(`/api/vulnerabilities/pentest/${pentestId}`, requestOptions);
};

export const apiVulnerabilitiesUpdate = async (
  token: string,
  vulnerability: ChangeVuln,
  options = {},
) => {
  const data = JSON.stringify(vulnerability);
  const config = {
    method: "put",
    maxBodyLength: Infinity,
    url: `/api/vulnerabilities/${vulnerability.id}`,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    data: data,
    ...options,
  };

  try {
    const response = await axios.request(config);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error; // Propagate the error
  }
};

export const apiCommandsUpdate2 = <TData = AxiosResponse<Command>>(
  token: string,
  id: number,
  command: NonReadonly<Command>,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  return axios.put(`/api/commands/${id}`, { command, options, headers });
};

// Generate model descriptions, executive summary etc for a given pentest id
export const apiGenerateRetrieve = <TData = AxiosResponse<Command[]>>(
  token: string,
  pentestId: number,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    method: "GET",
    headers: headers,
    timeout: 500000,
    ...options,
  };

  return axios.get(`/api/ai/${pentestId}`, requestOptions);
};

export const apiCommandsPentestList = <TData = AxiosResponse<Command[]>>(
  token: string,
  pentestId: number,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    method: "GET",
    headers: headers,
    ...options,
  };

  return axios.get(`/api/commands/pentest/${pentestId}`, requestOptions);
};

export const apiGetCommandByID = <TData = AxiosResponse<Command>>(
  token: string,
  commandID: number,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    method: "GET",
    headers: headers,
    ...options,
  };

  return axios.get(`/api/commands/${commandID}`, requestOptions);
};

export const apiGetRequestByID = <TData = AxiosResponse<NetworkRequest>>(
  token: string,
  requestID: number,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    method: "GET",
    headers: headers,
    ...options,
  };

  return axios.get(`/api/network_requests/${requestID}`, requestOptions);
};

export const apiGenerateSingleVulnerability = <
  TData = AxiosResponse<Vulnerability>,
>(
  token: string,
  vulnID: number,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    method: "GET",
    headers: headers,
    timeout: 500000,
    ...options,
  };

  return axios.get(`/api/ai/vulnerability/${vulnID}`, requestOptions);
};

//Get commands by pentest and vulnerability
export const apiCommandsPentestVulnerabilityList = <
  TData = AxiosResponse<Command[]>,
>(
  token: string,
  pentestId: number,
  vulnID: number,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    method: "GET",
    headers: headers,
    ...options,
  };

  return axios.get(
    `/api/commands/pentest/${pentestId}/vulnerability/${vulnID}`,
    requestOptions,
  );
};

/*
  Create an association between a vulnerability and a command
  Daca dai data doar {"command_id: 10"} o sa creeze o vulnerabilitate noua
  Daca dai {"command_id: 10", "vulnerability_id": 3} o sa lege comanda 10 de vulnerabilitatea 3
*/
export const apiCreateAssociationCreate = <TData = AxiosResponse<any>>(
  token: string,
  data: CommandConnection,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  return axios.post(`/api/command-associations/`, data, {
    headers,
    ...options,
  });
};

export const apiGeneratePdfRetrieve = <TData = AxiosResponse<BlobPart>>(
  token: string,
  pentestId: number,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    method: "GET",
    headers: headers,
    responseType: "blob",
    ...options,
  };

  return axios.get(`/api/generation/pdf/${pentestId}`, requestOptions);
};

export const apiNetworkRequestVulnerabilityAssociationDelete = <
  TData = AxiosResponse<void>,
>(
  token: string,
  data: NetworkRequestConnection,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const config = {
    method: "delete",
    url: `/api/network-associations/`, // Adjust URL as needed
    data,
    headers: headers,
    ...options,
  };

  return axios.request(config);
};

// get all pentests
export const apiPentestsList = <TData = AxiosResponse<Pentest[]>>(
  token: string,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    method: "GET",
    headers: headers,
    data: "",
    ...options,
  };

  return axios.get("/api/pentests/", requestOptions);
};

// create a new pentest
export const apiPentestsCreate = <TData = AxiosResponse<Pentest>>(
  token: string,
  pentest: Pentest,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  return axios.post(`/api/pentests/`, pentest, { headers, ...options });
};

export const apiVulnerabilitiesCreate = <TData = AxiosResponse<Vulnerability>>(
  token: string,
  vulnerability: CreateVuln,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  return axios.post(`/api/vulnerabilities/`, vulnerability, {
    headers,
    ...options,
  });
};

// get a pentest by its id
export const apiPentestsRetrieve = <TData = AxiosResponse<Pentest>>(
  token: string,
  id: number,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  return axios.get(`/api/pentests/${id}`, { headers });
};

//update a pentest
export const apiPentestsUpdate = <TData = AxiosResponse<Pentest>>(
  token: string,
  pentestId: number,
  pentestData: ChangePentest,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  return axios.put(
    `/api/pentests/${pentestId}`, // Adjust URL as needed
    pentestData,
    { headers, ...options },
  );
};

export const apiUserDetailsUpdate = <TData = AxiosResponse<void>>(
  token: string,
  userData: ContactInformation,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  return axios.put(
    `/api/user-details/`, // Adjust URL as needed
    userData,
    { headers, ...options },
  );
};

export const apiTokenRetrieve = <TData = AxiosResponse<{ token: string }>>(
  token: string,
  pentestId: number,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  return axios.get(`/api/pentests/token/${pentestId}`, { headers });
};


export const apiPentestsDelete = <TData = AxiosResponse<void>>(
  token: string,
  id: number,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const config = {
    method: "delete",
    maxBodyLength: Infinity,
    url: `/api/pentests/${id}`,
    headers: headers,
    ...options,
  };

  return axios.request(config);
};

export const apiVulnerabilitiesDelete = <TData = AxiosResponse<void>>(
  token: string,
  id: number,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const config = {
    method: "delete",
    maxBodyLength: Infinity,
    url: `/api/vulnerabilities/${id}`,
    headers: headers,
    ...options,
  };

  return axios.request(config);
};

export const apiTemplateCreate = <TData = AxiosResponse<Template>>(
  token: string,
  templateData: any, // Template without ID
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  return axios.post(`/api/templates/`, templateData, { headers, ...options });
};

export const apiTemplateUpdate = <TData = AxiosResponse<any>>(
  token: string,
  id: number,
  templateData: Template,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  return axios.put(`/api/templates/${id}`, templateData, { headers, ...options });
};

export const apiTemplateRetrieve = <TData = AxiosResponse<Template[]>>(token: string): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  return axios.get(`/api/templates/`, { headers });
};

export const apiTemplateDelete = <TData = AxiosResponse<void>>(
  token: string,
  id: number,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const config = {
    method: "delete",
    url: `/api/templates/${id}`,
    headers: headers,
    ...options,
  };

  return axios.request(config);
};

export const apiGetTemplateByID = <TData = AxiosResponse<Template>>(
  token: string,
  templateID: number,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    method: "GET",
    headers: headers,
    ...options,
  };

  return axios.get(`/api/templates/${templateID}`, requestOptions);
};

export const apiGetAppendixByTemplateID = <TData = AxiosResponse<AppendixFile[]>>(
  token: string,
  templateID: number,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    method: "GET",
    headers: headers,
    ...options,
  };

  return axios.get(`/api/appendix/template/${templateID}`, {
    ...requestOptions,
    transformResponse: [(data) => {
      const parsedData = JSON.parse(data);
      return parsedData.map((item: any) => ({
        ID: item.ID,
        OriginalName: item.OriginalName,
        Template: item.Template,
      }));
    }],
  });
};
// [
// {
//   "ID": 10,
//   "CreatedAt": "2025-02-18T14:46:34.084Z",
//   "UpdatedAt": "2025-02-18T14:46:34.084Z",
//   "DeletedAt": null,
//   "Path": "uploads/appendix/user_1_350b2078d9eae591.pdf",
//   "OriginalName": "",
//   "OrderNumber": 0,
//   "Template": 47
// },
// {
//   "ID": 11,
//   "CreatedAt": "2025-02-18T14:56:07.741Z",
//   "UpdatedAt": "2025-02-18T14:56:07.741Z",
//   "DeletedAt": null,
//   "Path": "uploads/appendix/user_1_3847044370d9f56d.pdf",
//   "OriginalName": "pentra-report.pdf",
//   "OrderNumber": 0,
//   "Template": 47
// }
// ]

export const apiGetAppendixByFileID = <TData = AxiosResponse<Blob>>(
  token: string,
  fileID: number,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    method: "GET",
    headers: headers,
    ...options,
  };

  return axios.get(`/api/appendix/file/${fileID}`, requestOptions);
};
// blob

export const apiPostAppendixFile = <TData = AxiosResponse<any>>(
  token: string,
  templateID: number,
  appendixFile: Blob,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const formData = new FormData();
  formData.append("appendix", appendixFile);

  const headers = {
    Authorization: `Bearer ${token}`,
    // "Content-Type": "multipart/form-data",
  };

  return axios.post(`/api/appendix/file/upload/template/${templateID}`, formData, {
    headers,
    ...options,
  });
};
// {
//   "appendixID": 11,
//   "message": "Appendix uploaded successfully",
//   "originalName": "pentra-report.pdf"
// }

export const apiDeleteAppendixFile = <TData = AxiosResponse<any>>(
  token: string,
  fileID: number,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const config = {
    method: "delete",
    url: `/api/appendix/${fileID}`,
    headers: headers,
    ...options,
  };

  return axios.request(config);
};
// {
//   "message": "Appendix deleted successfully"
// }

/**
 * Upload a logo for a specific template
 */
export const apiPostTemplateLogo = <TData = AxiosResponse<any>>(
  token: string,
  templateID: number,
  logoFile: Blob,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const formData = new FormData();
  formData.append("logo", logoFile);

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  return axios.post(`/api/templates/logo/${templateID}`, formData, {
    headers,
    ...options,
  });
};

/**
 * Get the logo for a specific template
 */
export const apiGetTemplateLogo = <TData = AxiosResponse<Blob>>(
  token: string,
  templateID: number,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    method: "GET",
    headers: headers,
    responseType: "blob",
    ...options,
  };

  return axios.get(`/api/templates/logo/${templateID}`, requestOptions);
};

/**
 * Delete the logo for a specific template
 */
export const apiDeleteTemplateLogo = <TData = AxiosResponse<any>>(
  token: string,
  templateID: number,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const config = {
    method: "delete",
    url: `/api/templates/logo/${templateID}`,
    headers: headers,
    ...options,
  };

  return axios.request(config);
};

export const apiGetTutorialStep = <TData = AxiosResponse<any>>(
  token: string,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    method: "GET",
    headers: headers,
    ...options,
  };

  return axios.get(`/api/user-details/tutorial-step`, requestOptions);
};
export const apiIncrementTutorialStep = <TData = AxiosResponse<any>>(
  token: string,
  options?: AxiosRequestConfig, // Optional Axios configurations
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  const requestOptions: AxiosRequestConfig = {
    headers: headers,
    ...options,
  };
  return axios.post(`/api/user-details/tutorial-step`, {}, requestOptions); // Empty body passed as second argument
};

// ------------------------------------------------ Collaboration functions generated with chatGPT ------------------------------------------------ 

export const apiCreateJoinToken = <TData = AxiosResponse<any>>(
  token: string,
  pentestId: number,
  role: RoleType,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    headers,
    ...options,
  };

  return axios.post(`/api/collaborations/create-join-token/${pentestId}`, { role: role }, requestOptions);
};

export const apiJoinPentest = <TData = AxiosResponse<any>>(
  token: string,
  joinToken: string, // Replace with specific type if known
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    headers,
    ...options,
  };

  return axios.post(`/api/collaborations/join`, { token: joinToken }, requestOptions);
};

export const apiLeavePentest = <TData = AxiosResponse<any>>( // TODO
  token: string,
  pentestId: number,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    headers,
    ...options,
  };

  return axios.delete(`/api/collaborations/leave/${pentestId}`, requestOptions);
};

export const apiGetCollaborators = <TData = AxiosResponse<any>>(
  token: string,
  pentestId: number,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    headers,
    ...options,
  };

  return axios.get(`/api/collaborations/${pentestId}`, requestOptions);
};

export const apiUpdateCollaborator = <TData = AxiosResponse<any>>( // to test
  token: string,
  pentestId: number,
  collaboratorId: number,
  role: RoleType,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    headers,
    ...options,
  };

  return axios.put(`/api/collaborations/${pentestId}/${collaboratorId}`, { role: role }, requestOptions);
};

export const apiDeleteCollaborator = <TData = AxiosResponse<any>>( // to test
  token: string,
  pentestId: number,
  collaboratorId: number,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const requestOptions: AxiosRequestConfig = {
    headers,
    ...options,
  };

  return axios.delete(`/api/collaborations/${pentestId}/${collaboratorId}`, requestOptions);
};


// ------------------------------------------------------------------------------------------------------------------------------------------------ 


export type ApiCommandsRetrieveResult = AxiosResponse<Command>;
export type ApiCommandsCreateResult = AxiosResponse<Command>;
export type ApiCommandsUpdateResult = AxiosResponse<Command>;
export type ApiCommandsRetrieve2Result = AxiosResponse<Command>;
export type ApiCommandsUpdate2Result = AxiosResponse<Command>;
export type ApiCommandsPartialUpdateResult = AxiosResponse<Command>;
export type ApiCommandsPentestListResult = AxiosResponse<Command[]>;
export type ApiCommandsPentestVulnerabilityListResult = AxiosResponse<
  Command[]
>;
export type ApiCreateAssociationCreateResult = AxiosResponse<void>;
export type ApiGeneratePdfRetrieveResult = AxiosResponse<void>;
export type ApiGenerateRetrieveResult = AxiosResponse<void>;
export type ApiLoginCreateResult = AxiosResponse<void>;
export type ApiPentestsListResult = AxiosResponse<Pentest[]>;
export type ApiPentestsCreateResult = AxiosResponse<Pentest>;
export type ApiPentestsRetrieveResult = AxiosResponse<Command>;
export type ApiPentestsUpdateResult = AxiosResponse<Command>;
export type ApiPentestsPartialUpdateResult = AxiosResponse<Command>;
export type ApiSignupCreateResult = AxiosResponse<void>;
export type ApiTestTokenRetrieveResult = AxiosResponse<void>;

export const apiUploadDocxTemplate = <TData = AxiosResponse<any>>(
  token: string,
  templateID: number,
  docxFile: File,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    'Content-Type': 'multipart/form-data',
    Authorization: `Bearer ${token}`,
  };

  const formData = new FormData();
  formData.append('docx', docxFile);

  const requestOptions = {
    headers,
    ...options,
  };

  return axios.post(`/api/templates/${templateID}/upload-docx`, formData, requestOptions);
};

export const apiGetDocxTemplate = <TData = AxiosResponse<Blob>>(
  token: string,
  templateID: number,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };

  const requestOptions = {
    headers,
    responseType: 'blob' as const,
    ...options,
  };

  return axios.get(`/api/templates/${templateID}/docx`, requestOptions);
};

export const apiDeleteDocxTemplate = <TData = AxiosResponse<void>>(
  token: string,
  templateID: number,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  const headers = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };

  const requestOptions = {
    headers,
    ...options,
  };

  return axios.delete(`/api/templates/${templateID}/delete-docx`, requestOptions);
};
